import { useLazyLoadQuery } from 'react-relay';

import { LIST_ICON_TASK_TYPE, LIST_PRIORITY, LIST_TASK_TYPE } from '../const';
import { ListItemsQuery } from '../graphql/ListItemsQuery';

const GantLoadListItem = () => {
    useLazyLoadQuery(ListItemsQuery, { type: LIST_TASK_TYPE }, { fetchPolicy: 'store-or-network' });
    useLazyLoadQuery(ListItemsQuery, { type: LIST_PRIORITY }, { fetchPolicy: 'store-or-network' });
    useLazyLoadQuery(ListItemsQuery, { type: LIST_ICON_TASK_TYPE }, { fetchPolicy: 'store-or-network' });

    return null;
};

export default GantLoadListItem;
